<template>
  <a-col v-bind="colAttrs" v-show="showItem" v-if="loadItem">
    <mtc-form-item v-bind="itemAttrs" :label="labelText">
      <slot></slot>
    </mtc-form-item>
  </a-col>
</template>

<script>
import { FormItemMixin } from './FormItenMixin'

export default {
  name: 'FormitemWapper',
  mixins: [FormItemMixin],
  inject: ['sh'],
  computed: {
    labelText(){
      return this.$getLanguageEnable() ? `dynamic.${this.labelLangKey}` : this.label
    },
    showItem: {
      get() {
        if (this.formitem.type == 'hidden') {
          return false
        } else {
          if (!this.formitem.subKey) {
            return this.sh[ this.formitem.key ]
          } else {
            return this.sh[ this.formitem.subKey ][ this.formitem.key ]
          }
        }
      }
    },
    loadItem: {
      get() {
        if (!this.formitem.subKey) {
          return this.sh[ this.formitem.key + '_load' ]
        } else {
          return this.sh[ this.formitem.subKey ][ this.formitem.key + '_load' ]
        }

      }
    }
  },
  data() {
    return {}
  }
}
</script>

<style scoped></style>